import EquipmentFiltersForm from "./equipment-filters-form";

export default EquipmentFiltersForm;